export class SelectionManager extends EventTarget {
  constructor() {
    super();
    this.selectedObjectId = null;
  }

  select(objectId) {
    if (this.selectedObjectId === objectId) return;
    this.selectedObjectId = objectId ?? null;
    this.dispatchEvent(new Event('change'));
  }

  clear() {
    this.select(null);
  }
}
